<div #pageContainer class="flex flex-col h-full">
  @if (loading) {
    <maximizer-loader type="legacy"></maximizer-loader>
  }

  @if (form) {
    <div class="flex flex-col h-full overflow-hidden">
      <div class="flex-1 overflow-y-auto scrollbar pb-4">
        <form class="flex flex-col p-4 text-xs" [formGroup]="form.group">
          <kendo-formfield>
            <kendo-label
              [for]="firstName"
              [text]="'outlook.lead.firstName' | translate"
            ></kendo-label>
            <kendo-textbox
              #firstName
              formControlName="firstName"
              [maxlength]="80"
            ></kendo-textbox>
            <maximizer-outlook-form-error
              [errorObject]="form.controls.firstName.errors"
              [fieldTranslation]="'outlook.lead.firstName'"
            ></maximizer-outlook-form-error>
          </kendo-formfield>

          <kendo-formfield class="mt-2" showErrors="always">
            <kendo-label
              [for]="lastName"
              [text]="'outlook.lead.lastName' | translate"
              >*</kendo-label
            >
            <kendo-textbox
              required
              #lastName
              formControlName="lastName"
              [maxlength]="80"
            ></kendo-textbox>
            <maximizer-outlook-form-error
              [errorObject]="form.controls.lastName.errors"
              [fieldTranslation]="'outlook.lead.lastName'"
            ></maximizer-outlook-form-error>
          </kendo-formfield>

          <kendo-formfield class="mt-2">
            <kendo-label
              [for]="email"
              [text]="'outlook.lead.email' | translate"
            ></kendo-label>
            <kendo-textbox
              #email
              formControlName="email"
              [ngClass]="'text-neutral-70'"
              [readonly]="true"
            ></kendo-textbox>
          </kendo-formfield>

          <kendo-formfield class="mt-2">
            <kendo-label
              [for]="phone1"
              [text]="'outlook.lead.phone1' | translate"
            ></kendo-label>
            <kendo-textbox
              #phone1
              formControlName="phone1"
              [maxlength]="22"
            ></kendo-textbox>
            <maximizer-outlook-form-error
              [errorObject]="form.controls.phone1.errors"
              [fieldTranslation]="'outlook.lead.phone1'"
            ></maximizer-outlook-form-error>
          </kendo-formfield>

          @if (addPhone2) {
            <kendo-formfield class="mt-2">
              <kendo-label
                [for]="phone2"
                [text]="'outlook.lead.phone2' | translate"
              ></kendo-label>
              <div class="flex">
                <kendo-textbox
                  #phone2
                  formControlName="phone2"
                  [maxlength]="22"
                ></kendo-textbox>
                <button
                  kendoButton
                  themeColor="primary"
                  fillMode="flat"
                  class="ml-1"
                  (click)="onRemovePhone()"
                  iconClass="fa-icons icon-solid icon-12 icon-trash-can"
                ></button>
              </div>
              <maximizer-outlook-form-error
                [errorObject]="form.controls.phone2.errors"
                [fieldTranslation]="'outlook.lead.phone2'"
              ></maximizer-outlook-form-error>
            </kendo-formfield>
          }

          <div class="flex justify-end pt-1">
            <button
              kendoButton
              themeColor="primary"
              fillMode="flat"
              class="text-inline-button"
              [ngClass]="addPhone2 ? 'text-neutral-60' : ''"
              (click)="addPhone2 = true"
              [disabled]="addPhone2"
              iconClass="fa-icons icon-solid icon-12 icon-plus"
            >
              {{ 'outlook.lead.add-phone' | translate }}
            </button>
          </div>

          <kendo-formfield class="mt-2">
            <kendo-label
              [for]="company"
              [text]="'outlook.lead.company' | translate"
            ></kendo-label>
            <kendo-textbox
              #company
              formControlName="company"
              [maxlength]="80"
            ></kendo-textbox>
            <maximizer-outlook-form-error
              [errorObject]="form.controls.company.errors"
              [fieldTranslation]="'outlook.lead.company'"
            ></maximizer-outlook-form-error>
          </kendo-formfield>

          <kendo-formfield class="mt-2">
            <kendo-label
              [for]="position"
              [text]="'outlook.lead.position' | translate"
            ></kendo-label>
            <kendo-textbox
              #position
              formControlName="position"
              [maxlength]="80"
            ></kendo-textbox>
            <maximizer-outlook-form-error
              [errorObject]="form.controls.position.errors"
              [fieldTranslation]="'outlook.lead.position'"
            ></maximizer-outlook-form-error>
          </kendo-formfield>

          <kendo-formfield class="mt-2">
            <kendo-label
              [for]="website"
              [text]="'outlook.lead.website' | translate"
            ></kendo-label>
            <kendo-textbox
              #website
              formControlName="website"
              [maxlength]="256"
            ></kendo-textbox>
            <maximizer-outlook-form-error
              [errorObject]="form.controls.website.errors"
              [fieldTranslation]="'outlook.lead.website'"
            ></maximizer-outlook-form-error>
          </kendo-formfield>

          <kendo-formfield class="mt-4">
            <kendo-label
              [for]="address1"
              [text]="'outlook.lead.address1' | translate"
            ></kendo-label>
            <kendo-textbox
              #address1
              formControlName="address1"
              [maxlength]="80"
            ></kendo-textbox>
            <maximizer-outlook-form-error
              [errorObject]="form.controls.address1.errors"
              [fieldTranslation]="'outlook.lead.address1'"
            ></maximizer-outlook-form-error>
          </kendo-formfield>
          <kendo-formfield class="mt-2">
            <kendo-label
              [for]="address2"
              [text]="'outlook.lead.address2' | translate"
            ></kendo-label>
            <kendo-textbox
              #address2
              formControlName="address2"
              [maxlength]="80"
            ></kendo-textbox>
            <maximizer-outlook-form-error
              [errorObject]="form.controls.address2.errors"
              [fieldTranslation]="'outlook.lead.address2'"
            ></maximizer-outlook-form-error>
          </kendo-formfield>
          <kendo-formfield class="mt-2">
            <kendo-label
              [for]="city"
              [text]="'outlook.lead.city' | translate"
            ></kendo-label>
            <kendo-textbox
              #city
              formControlName="city"
              [maxlength]="80"
            ></kendo-textbox>
            <maximizer-outlook-form-error
              [errorObject]="form.controls.city.errors"
              [fieldTranslation]="'outlook.lead.city'"
            ></maximizer-outlook-form-error>
          </kendo-formfield>
          <kendo-formfield class="mt-2">
            <kendo-label
              [for]="province"
              [text]="'outlook.lead.province' | translate"
            ></kendo-label>
            <kendo-textbox
              #province
              formControlName="province"
              [maxlength]="80"
            ></kendo-textbox>
            <maximizer-outlook-form-error
              [errorObject]="form.controls.province.errors"
              [fieldTranslation]="'outlook.lead.province'"
            ></maximizer-outlook-form-error>
          </kendo-formfield>
          <kendo-formfield class="mt-2">
            <kendo-label
              [for]="postalCode"
              [text]="'outlook.lead.postalCode' | translate"
            ></kendo-label>
            <kendo-textbox
              #postalCode
              formControlName="postalCode"
              [maxlength]="80"
            ></kendo-textbox>
            <maximizer-outlook-form-error
              [errorObject]="form.controls.postalCode.errors"
              [fieldTranslation]="'outlook.lead.postalCode'"
            ></maximizer-outlook-form-error>
          </kendo-formfield>

          <kendo-formfield class="mt-2">
            <kendo-label
              [for]="country"
              [text]="'outlook.lead.country' | translate"
            ></kendo-label>

            <kendo-dropdownlist
              #country
              [data]="countries"
              formControlName="country"
              [defaultItem]="{
                name: 'outlook.lead.country-placeholder' | translate,
                id: '',
              }"
              [virtual]="{ itemHeight: 40 }"
              valueField="id"
              textField="name"
              [valuePrimitive]="true"
            >
            </kendo-dropdownlist>
          </kendo-formfield>
        </form>
      </div>

      <div class="bg-neutral-5 z-40 flex justify-end gap-2 p-2">
        <button
          kendoButton
          id="outlook-lead-ui-editLead-cancel"
          class="uppercase"
          themeColor="primary"
          fillMode="flat"
          (click)="cancel()"
          [disabled]="loading"
        >
          {{ 'outlook.buttons.cancel' | translate }}
        </button>
        <button
          kendoButton
          id="outlook-lead-ui-editLead-save"
          class="uppercase"
          themeColor="primary"
          [disabled]="!form.valid"
          (click)="save()"
        >
          {{ 'outlook.buttons.save' | translate }}
        </button>
      </div>
    </div>
  }
</div>

<maximizer-outlook-notification #notification [closable]="true" entryId="lead">
</maximizer-outlook-notification>
